import { useEffect, type ReactNode } from 'react';
import { ConfigProvider, App as AntdApp, theme as antdTheme } from 'antd';
import { useThemeStore, useThemeSync } from '@shared/lib/theme-store';

const BRAND = {
  colorPrimary: '#2563eb',
  colorInfo: '#2563eb',
  colorSuccess: '#16a34a',
  colorWarning: '#d97706',
  colorError: '#dc2626',
  borderRadius: 8,
  fontFamily: 'Inter, ui-sans-serif, system-ui, sans-serif',
};

export function ThemeProvider({ children }: { children: ReactNode }) {
  useThemeSync();
  const resolved = useThemeStore((s) => s.resolved);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', resolved === 'dark');
    root.style.colorScheme = resolved;
  }, [resolved]);

  return (
    <ConfigProvider
      theme={{
        algorithm:
          resolved === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: BRAND,
        cssVar: true,
        hashed: false,
      }}
    >
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
}
